import api from '../REST/api';
import createExportDump from '../utils/create-export-dump';

const dump = createExportDump(
  api.exportOpportunities,
  'stage',
  'opportunities',
);

export default dump;
